// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-P1":"P1_vanlife-roadtrips-P1__35a0j"};